import React from "react";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";

const SpringboardBadgeCard = ({ emoji, title, category, certificatePath }) => {
  const CardContent = (
    <div className="badge-card-inner">
      <div className="badge-emblem-wrapper">
        <span className="badge-emoji-symbol" role="img" aria-label={title}>
          {emoji}
        </span>
      </div>
      <div className="badge-details">
        <h3 className="badge-title">{title}</h3>
        <p className="badge-organization">Infosys Springboard</p>
        <span className="badge-category-tag">{category}</span>
      </div>
      {certificatePath && (
        <span className="badge-view-indicator">
          View Certification <FaExternalLinkAlt className="indicator-icon" />
        </span>
      )}
    </div>
  );

  if (certificatePath) {
    return (
      <Link
        to={certificatePath}
        className="springboard-badge-card clickable"
        aria-label={`View ${title} badge certificate on Infosys Springboard page`}
      >
        {CardContent}
      </Link>
    );
  }

  return <div className="springboard-badge-card">{CardContent}</div>;
};

export default SpringboardBadgeCard;
